export default __webpack_public_path__ + "static/media/linkedin.38f950fe.svg";